import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const Portal = ({ children, appContainerId = 'app-main', modalRootId = 'portal-root' }) => {
  const el = React.useRef(document.createElement('div'));

  React.useEffect(() => {
    let modalRoot = document.getElementById(modalRootId);
    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.id = modalRootId;
      const appRoot = document.getElementById(appContainerId) || document.querySelector('body');
      if (appRoot) appRoot.appendChild(modalRoot);
    }
    modalRoot.appendChild(el.current);
    return () => {
      modalRoot.removeChild(el.current);
      if (modalRoot.children.length === 0) {
        modalRoot.remove();
      }
    };
  }, []);

  return ReactDOM.createPortal(children, el.current);
};

Portal.propTypes = {
  appContainerId: PropTypes.string,
  modalRootId: PropTypes.string,
  children: PropTypes.node,
};

export default Portal;
